import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "columns is-vcentered" }
const _hoisted_3 = { class: "column" }
const _hoisted_4 = { class: "navbar-item" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "icon-edit" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_HeaderActions = _resolveComponent("HeaderActions")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.truncateLong(_ctx.corpus.name)), 1),
          (_ctx.isVerified)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: { name: 'corpus-update', params: { corpusId: _ctx.corpusId } },
                title: "Project information",
                class: "ml-1"
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_HeaderActions, { "corpus-id": _ctx.corpusId }, null, 8, ["corpus-id"])
    ])
  ]))
}